export const hcpType = {
    Prescriber: 'Prescriber',
    GroupPractice: 'Prescriber Group Practice',
    GeographyAggregate : 'Geographic Aggregate'
}

export const focusTypeName = {
    HCPs: 'HCPs',
    Messages: 'Messages'
}

export const printJobStatus = {
    Error: -1,
    Inititated: 0,
    Queued: 1,
    Completed: 2,
    Cancelled: 3,
}

export const columnWidthOptions = {
    Half: 0,
    Single: 1,
    Double: 2,
    Triple: 3,
}

export const Roles = {
    Admin: 'Admin',
    User: 'User',
    Manager: 'Manager',
    Precision: 'Precision'
}

export const hcpTab = {
    Prescriber: '1',
    GroupPractice: '2',
    GeographyAggregate: '3'
}

export const announcmentPartition = "Dashboard";

export const planListIconType = {
    Formulary: 'Formulary',
    SpecialtyPharmacy: 'SpecialtyPharmacy',
    RestrictionNotes: 'RestrictionNotes',
}

export const quickSheetTypeMessageId = -999;

export const OppScore = {
    Score: {
        High: 3,
        Medium: 2,
        Low: 1,
    },
    ClassName: {
        Base: 'badge-opportunity-score',
        High: 'badge-opportunity-score badge-opportunity-score-high',
        Medium: 'badge-opportunity-score badge-opportunity-score-medium',
        Low: 'badge-opportunity-score badge-opportunity-score-low',
    },
};